import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=713b3340&scoped=true&"
import script from "./ComingSoon.vue?vue&type=script&lang=js&"
export * from "./ComingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b3340",
  null
  
)

export default component.exports